import React from 'react';
import { CUIText, Image } from '@dotcom/crown-ui';
import { InstructionStepProps } from '../wam-instructions-drawer-types';
import styles from '../wam-instructions-drawer.module.scss';

export const InstructionStep = ({ title, text, imageUrl, stepNumber }: InstructionStepProps) => {
  return (
    <div className={styles['instruction-step']}>
      <div className={styles['instruction-image-wrapper']}>
        <Image src={imageUrl} className={styles['instruction-image']} alt="" />
        <CUIText as="span" size="small" className={styles['badge']}>
          {stepNumber}
        </CUIText>
      </div>
      <div className={styles['instruction-text']}>
        <CUIText variant="h5" className={styles['step-title']} color="textPrimary">
          {title}
        </CUIText>
        <CUIText className={styles['step-description']}>{text}</CUIText>
      </div>
    </div>
  );
};
